<template>
  <Alert
    :show="show"
    :title="$t('common.mobile.menu.disabled.title')"
    :message="$t('common.mobile.menu.disabled.text')"
    :display-cancel-button="false"
    :confirm-text="$t('common.close')"
    :show-alert-icon="!designSystem"
    :width="designSystem ? 400 : 478"
    @confirm="emit('confirm')"
  >
    <!-- Design-system look: a desktop in a brand tile instead of the warning sign - nothing went
         wrong, the page just wants a bigger screen. -->
    <template v-if="designSystem" #default>
      <div class="text-center" data-test="desktop-only-dialog">
        <!-- eslint-disable vue/no-v-html -- the static design-system icon -->
        <span
          class="mx-auto mb-4 flex size-14 items-center justify-center rounded-(--ds-radius-lg) bg-(--ds-surface-brand) text-(--ds-text-brand) [&>svg]:size-7"
          aria-hidden="true"
          v-html="ICONS.desktop"
        />
        <!-- eslint-enable vue/no-v-html -->
        <h3
          class="mb-2 text-[20px] font-bold tracking-[-0.3px] text-(--ds-text-primary)"
          v-text="$t('common.mobile.menu.disabled.title')"
        />
        <p
          class="text-[15px] leading-[1.55] text-(--ds-text-secondary)"
          v-text="$t('common.mobile.menu.disabled.text')"
        />
      </div>
    </template>
  </Alert>
</template>

<script setup>
import Alert from '@/Components/Alert.vue'
import { useDesignSystem } from '@/composables/designSystem'
import { ICONS } from '@/Libraries/design-system-icons'

defineProps({
  show: {
    type: Boolean,
    default: () => false,
  },
})

const emit = defineEmits(['confirm'])

const designSystem = useDesignSystem()
</script>
